var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M24 0v24H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 13.586 6.707 8.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414z",
  "data-name": "Shape"
}))));
export { SvgChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZGF0YS1uYW1lPSJHcm91cCAxMiI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTI0IDB2MjRIMFYweiIvPjxwYXRoIGRhdGEtbmFtZT0iU2hhcGUiIGQ9Ik0xMiAxMy41ODZMNi43MDcgOC4yOTNhMSAxIDAgMDAtMS40MTQgMS40MTRsNiA2YTEgMSAwIDAwMS40MTQgMGw2LTZhMSAxIDAgMDAtMS40MTQtMS40MTR6Ii8+PC9nPjwvc3ZnPg==";